// extracted by mini-css-extract-plugin
module.exports = {"item_content":"itemcontent_item_content__2RM7M","image":"itemcontent_image__3RiH-","video":"itemcontent_video__1q6AG","container_image":"itemcontent_container_image__2UGdU"};